import { useContext } from "react";
import { DueDateContext } from "../contexts/DueDateContext";

const useSubmissionDate = () => {
  const { windowStatus } = useContext(DueDateContext);
  const isWindowClosed = "OPEN" != windowStatus;

  return { outsideSubmissionDate: isWindowClosed };
};

export default useSubmissionDate;
